/* eslint-disable max-classes-per-file */

const datasetClasses = [];

export class Dataset {
	static type = 'generic';

	static subType = null;

	static basedata = false;

	static displayName = 'Generic';

	constructor() {
		this.data = {};
	}

	toJSON() {
		const props = {};
		for (const x in this) {
			if (Object.prototype.hasOwnProperty.call(this, x)) {
				props[x] = this[x];
			}
		}
		props.type = this.constructor.type;
		props.subType = this.constructor.subType;
		props.basedata = this.constructor.basedata;
		return props;
	}
}
datasetClasses.push(Dataset);

export class BaseDataset extends Dataset {
	static basedata = true;
}



// create primaryTypes<primaryType><subType>
const primaryTypes = {};
datasetClasses.forEach((datasetClass) => {
	let primaryTypeSet = primaryTypes[datasetClass.type];
	if (!primaryTypeSet) primaryTypeSet = primaryTypes[datasetClass.type] = {};
	primaryTypeSet[datasetClass.subType] = datasetClass;
});

/**
 * Constructo dataset class from plain dataset
 * @param {Object} plainDataset
 * @return {Dataset}
 */
export function createDatasetFromPlainDataset(plainDataset) {
	const primaryType = primaryTypes[plainDataset.type];
	if (!primaryType) throw new Error('Unknown primary type');
	const DatasetConstructor = primaryType[plainDataset.subType];
	if (!DatasetConstructor) throw new Error('Unknown subtype');
	const dataset = new DatasetConstructor();
	dataset.data = plainDataset.data ? { ...dataset.data, ...plainDataset.data } : dataset.data;
	return dataset;
}